import { Readable } from 'interfaces/readable';

export default class HEXColor implements Readable {
  private readonly hex: string;

  constructor(hex: string) {
    this.hex = hex;
  }

  value() {
    return this.hex;
  }

  toString() {
    return this.hex;
  }
}
